import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Icon } from 'antd';
import { setIcon } from '../../services/setIcon';
import { Link } from "react-router-dom";

const UserCart = ({totalCart, brandName, isMember, closeNavMenu}, context) => {
    if (isMember) {
      return (
        <Link
          to="/cart"
          className="nav-link"
          onClick={closeNavMenu}
        >
        <span className="md:hidden text-primary">{context.t('Shopping Cart')}</span>

        <Badge count={totalCart && totalCart} className={"badge-cart"} offset={[-18, -7]}>
          <Icon component={setIcon('cart')} style={{ fontSize: '24px' }} />
        </Badge>
      </Link>
      )
    }
    return null;
}

UserCart.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default UserCart;
